/**
 * useSegnalaErrore — F-007 Phase 4 (IMPL-P4-004).
 *
 * Mutation per segnalare un errore su una pratica in carico
 * (`POST /:id/segnala-errore`). La pratica passa in `BLOCCATA` e — best
 * effort — il backend enqueua l'email Brevo verso il cliente (Phase 3).
 *
 * Invalida queue + my-assigned al successo.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { SegnalazioneInput } from '@app/shared';
import { operatorClient } from '../lib/operator-client';

export interface UseSegnalaErroreVars {
  praticaId: string;
  input: SegnalazioneInput;
}

export function useSegnalaErrore() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ praticaId, input }: UseSegnalaErroreVars) =>
      operatorClient.segnalaErrore(praticaId, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['operator', 'queue'] });
      qc.invalidateQueries({ queryKey: ['operator', 'my-assigned'] });
    },
  });
}
